import type {ForestMassStatusesRepository, filters} from '@/domain/interfaces/ForestMassStatusesRepository';

export class GetAllForestMassStatusesUseCase {
  constructor(private readonly repository: ForestMassStatusesRepository) {}
  async execute(filters?: filters) {
    return this.repository.getAll(filters);
  }
}
